export const MEDIA_PERMISSIONS = {
    PROMPT: "prompt",
    PROMPT_VALUE: "3",
    GRANTED: "granted",
    GRANTED_VALUE: "1",
    BLOCKED: "denied",
    BLOCKED_VALUE: "2",
    ERROR: "dismissed",
};

export const INPUT_OUTPUT_DEVICE_TYPE = {
    CAMERA: "videoinput",
    MIC: "audioinput",
    SPEAKER: "audiooutput",
};

export const MEDIA_DEVICE_PERMISSION_QUERY_TYPE = {
    CAMERA: "camera",
    MIC: "microphone",
};

export const CAMERA_FACING_MODE = {
    FRONT: "user",
    BACK: "environment",
};
export const CAMERA_FACE = {
    OFF: "0",
    FRONT: "2",
    BACK: "1",
};

export const CAMERA_ISSUE_DEVICES = [
    "SM-N976B",
    "SM-N976F",
    "SM-N976U",
    "SM-N976",
    "SM-N976N",
    "SM-N976V",
    "SM-N9760",
    "SM-N976Q",
    "SM-N975F",
    "SM-N975U",
    "SM-N9750",
    "SM-N975U1",
    "SM-N975W",
    "SM-N975N",
    "SM-N975X",
    "SM-G985F",
    "SM-G986B",
    "SM-G986",
    "SM-G986F",
    "SM-G986F/DS",
    "SM-G986U",
    "SM-G986U1",
    "SM-G9860",
    "SM-G986B/DS",
    "SM-G986N",
    "SM-G980F",
    "SM-G981B",
    "SM-G981N",
    "SM-G981U",
    "SM-G981U1",
    "SM-G981W",
    "SM-G988F",
    "SM-G986W",
    "SM-G988B",
    "SM-G988N",
    "SM-G988U",
    "SM-G988U1",
    "SM-G988W",
    "SM-G988F/DS",
];

export const BACK_CAMERA_LABEl_LIST = [
    { name: "back" },
    { name: "arrière" },
    { name: "trás" },
    { name: "traseira" },
    { name: "trasera" },
    { name: "rückkamera" },
];

export const FRNOT_CAMERA_LABEL_LIST = [{ name: "front" }, { name: "avant" }, { name: "frente" }, { name: "frontal" }, { name: "frontkamera" }];

export const VIDEO_QUALITY_LIST = [
    {
        value: "low",
        labelKey: "low_bandwidth",
    },
    {
        value: "medium",
        labelKey: "adaptive",
    },
    {
        value: "high",
        labelKey: "high_quality",
    },
];

export const VIDEO_FPS = 20;

export const MAX_VIDEO = {
    maxVideoWidthWeb: 1280,
    maxVideoHeightWeb: 720,
    maxVideoWidthMobile: 640,
    maxVideoHeightMobile: 480,
};

export const SCREEN_SHARE_DIMENSION = {
    width: 1920,
    height: 1080,
};

export const SCREENSHARE_FPS = 15;

export const DEFAULT_VIDEO_QUALITY = VIDEO_QUALITY_LIST[1];

export const QUALITY_TYPE_MAP = {
    LD: "low",
    SD: "medium",
    HD: "high",
};

/* These error types are types of error listed in, library which is common for all browsers */
export const ERROR_TYPE = {
    CAM_IN_USE: "cam-in-use",
    MIC_IN_USE: "mic-in-use",
    CAM_OR_MIC_IN_USE: "cam-mic-in-use",
    PERMISSION: "permissions",
    UNDEFINED_MEDIA_DEVICE: "undefined-mediadevices",
    NOT_FOUND: "not-found",
    CONSTRAINT: "constraints",
    UNKNOWN: "unknown",
    TRACK_PUBLICATION_FAILED: "track-publication-failed",
    TRACK_SUBSCRIPTION_FAILED: "track-subscription-failed",
    NOT_READABLE: "not-readable",
};
